<template>
  <div>
    <vxe-grid
      border
      resizable
      auto-resize
      highlight-hover-row
      size="small"
      row-id="pendingGoodsInspectionCode"
      :data="data"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template #toolbar_form>
        <slot name="header"></slot>
      </template>

      <template #pager>
        <slot name="pager"></slot>
      </template>

      <template #opt="{ row }">
        <el-button
          class="view-button"
          @click="
            $emit('openEditPage', {
              pageType: 'detail',
              params: { pendingGoodsInspectionCode: row.pendingGoodsInspectionCode },
              query: { pendingGoodsInspectionNo: row.pendingGoodsInspectionNo },
            })
          "
        >
          {{ $l('btn_view') || '查看详情' }}
        </el-button>
      </template>

      <template #status="{ row }">
        <InspectionStatus :value="row.status" :label="row.statusText" />
      </template>

      <template #checkStatus="{ row }">
        <InspectionCheckStatus
          :value="row.checkStatus"
          :label="row.checkStatusText"
        />
      </template>

      <template #displayRecheck="{ row }">
        <span>{{ row.recheckByName }}</span>
        <br />
        <span>{{ row.recheckTime }}</span>
      </template>

      <template #displayCreate="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createTime }}</span>
      </template>

      <template #displayModify="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyTime }}</span>
      </template>

      <template #empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import lodash from 'lodash'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import TableAutoHeight from '@/mixins/table-auto-height'
import InspectionStatus from '../inspection-status'
import InspectionCheckStatus from '../inspection-check-status'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { InspectionStatus, InspectionCheckStatus },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    data() {
      if (!this.tableData?.length) return []

      return lodash.map(this.tableData, (item) => {
        const { spec, specUnit, listUser } = item

        const reportPerson = lodash
          .map(listUser, (user) =>
            [user.userName, user.userNo ? `（${user.userNo}）` : '']
              .filter(Boolean)
              .join(''),
          )
          .join('\n')

        const goodsSpec = [spec, specUnit].filter(Boolean).join(' ')

        return {
          ...item,
          reportPerson,
          goodsSpec,
        }
      })
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.view-button {
  padding: 0;
  width: 70px;
  height: 30px;
  border: none;
  border-radius: 5px !important;
  font-weight: 400;
  color: #6c6c6c;
  background-color: #f8f8f8;
}
</style>
